import { Component } from '@angular/core';

@Component({
  selector: 'app-economicperformance',
  templateUrl: './economicperformance.component.html',
  styleUrl: './economicperformance.component.scss',
})
export class EconomicperformanceComponent {
  sectors = [
    {
      title: 'قطاع التعدين',
      bg: 'assets/sectors/mining.png',
      icon: 'assets/sectors/miningW.png',
      route: '/mining',
    },
    {
      title: 'قطاع الاتصالات وتكنولوجيا المعلومات',
      bg: 'assets/sectors/it.png',
      icon: 'assets/sectors/innovationW.png',
      route: '/it',
    },
    {
      title: 'قطاع العقارات',
      bg: 'assets/sectors/construction.png',
      icon: 'assets/sectors/constructionW.png',
      route: '/realState',
    },
    {
      title: 'قطاع الرعاية الصحية',
      bg: 'assets/sectors/healthCare.png',
      icon: 'assets/sectors/healthCareW.png',
      route: '/healthcare',
    },
    {
      title: 'قطاع الخدمات المالية والتأمين',
      bg: '../../assets/sectors/Financial.jpg',
      icon: 'assets/sectors/finicialicon.png',
      route: '/financial',
    },
    {
      title: 'قطاع التعليم',
      bg: 'assets/sectors/education.jpg',
      icon: 'assets/sectors/Education.png',
      route: '/education',
    },
    {
      title: 'قطاع الصناعات الدوائية والطبية',
      bg: 'assets/sectors/pharmaceris.png',
      icon: 'assets/sectors/pharmacerisW.png',
      route: '/pharmaceutical',
    },
    {
      title: 'قطاع السياحة',
      bg: 'assets/sectors/Tourism.jpg',
      icon: 'assets/sectors/tourismSector.png',
      route: '/tourism',
    },
    {
      title: 'قطاع الزراعة واستصلاح الأراضي',
      bg: 'assets/sectors/AgiBusiness.png',
      icon: 'assets/sectors/tractorW.png',
      route: '/agriculture',
    },
    {
      title: 'قطاع الغزل والنسيج',
      bg: 'assets/sectors/Textstiles.jpg',
      icon: 'assets/sectors/textiles.png',
      route: '/textiles',
    },
    {
      title: 'قطاع الغاز والبترول',
      bg: 'assets/sectors/oilandgaspic.jpg',
      icon: 'assets/sectors/oilandgases.png',
      route: '/oilgas',
    },
    {
      title: 'قطاع الصناعات الغذائية',
      bg: 'assets/sectors/foodprocessingpic.jpg',
      icon: 'assets/sectors/foodprocessings.png',
      route: '/foodprocessing',
    },
  ];
}
